import '../styles/main.scss';

import App from "./App.js"

window.addEventListener(
  "load",
  function () {
    gsap.registerPlugin(Draggable, Flip, InertiaPlugin, PhysicsPropsPlugin, ScrollTrigger, ScrollToPlugin, SplitText);
    window.app = new App();
  },
  false
);

function setVH() {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
  requestAnimationFrame(() => {
    window.ScrollTrigger?.refresh()
  })
}

setVH()

window.addEventListener('resize', setVH);
window.addEventListener('load', setVH);